const MAP = {
  draft: ["Draft", "bg-slate-100 text-slate-700 border-slate-300", "bg-slate-400"],
  submitted: ["Submitted", "bg-blue-50 text-blue-700 border-blue-200", "bg-blue-500"],
  under_review: ["Under Review", "bg-amber-50 text-amber-700 border-amber-200", "bg-amber-500"],
  approved: ["Approved", "bg-emerald-50 text-emerald-700 border-emerald-200", "bg-emerald-500"],
  rejected: ["Rejected", "bg-rose-50 text-rose-700 border-rose-200", "bg-rose-500"],
  archived: ["Archived", "bg-purple-50 text-purple-700 border-purple-200", "bg-purple-500"],
};

export const statusLabel = (s) => MAP[s]?.[0] || s;

export const StatusBadge = ({ status, testid }) => {
  const [label, cls, dot] = MAP[status] || [status, "bg-slate-100 text-slate-700 border-slate-300", "bg-slate-400"];
  return (
    <span data-testid={testid || `status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded border text-xs font-semibold whitespace-nowrap ${cls}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />
      {label}
    </span>
  );
};

export const RefPill = ({ value, testid }) => (
  <span data-testid={testid} className="font-mono text-xs font-bold text-slate-800 bg-slate-100 px-2 py-0.5 rounded border border-slate-200 whitespace-nowrap">
    {value}
  </span>
);

export const PageHeader = ({ eyebrow, title, children, testid }) => (
  <div className="flex flex-col sm:flex-row sm:items-end gap-4 justify-between mb-6 fade-up print:hidden">
    <div>
      {eyebrow && <div className="text-[11px] font-semibold uppercase tracking-[0.22em] text-amber-700 dark:text-amber-300/90 mb-1.5">{eyebrow}</div>}
      <h1 data-testid={testid} className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">{title}</h1>
    </div>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);
